import React from "react";
import { FaEnvelope, FaLocationArrow, FaMobileScreen } from "react-icons/fa6";
import Payment from "../../assets/payments.png";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="col">
          <div className="title">About</div>
          <div className="text">
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Repellat
            quibusdam suscipit iure ut, ipsum voluptatem delectus incidunt quos
            doloremque at, asperiores dicta optio beatae quidem! Est quos in
            magnam quae
          </div>
        </div>
        <div className="col">
          <div className="title">Contact</div>
          <div className="c-item">
            <FaLocationArrow />
            <div className="text">
              1X1, Sunset Avenue, Windsor, Ontario, Canada, N9B 2H4
            </div>
          </div>
          <div className="c-item">
            <FaMobileScreen />
            <div className="text">Phone: 519-452-XXXX</div>
          </div>
          <div className="c-item">
            <FaEnvelope />
            <div className="text">Email: neelpXXX@gmail.com</div>
          </div>
        </div>
        <div className="col">
          <div className="title">Categories</div>
          <span className="text">Headphones</span>
          <span className="text">Smart Watches</span>
          <span className="text">Bluetooth Speakers</span>
          <span className="text">Wireless Earbuds</span>
          <span className="text">Home Theatre</span>
          <span className="text">Projectors</span>
        </div>
        <div className="col">
          <div className="title">Pages</div>
          <span className="text">Home</span>
          <span className="text">About</span>
          <span className="text">Privacy Policy</span>
          <span className="text">Returns</span>
          <span className="text">Terms & Conditions</span>
          <span className="text">Contact Us</span>
        </div>
      </div>
      <div className="bottom-bar">
        <div className="bottom-bar-content">
          <div className="text">
            Premium E-commerce Solutions - MYELITESTORE 2024. Copyright &copy;
            Neel Patel. All rights reserved.
          </div>
          <img src={Payment} alt="Payment" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
